const RATE_COMPARISON_EPSILON = 0.01;

const toNumber = (value) => {
    if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) {
        return null;
    }

    const number = Number(value);
    return Number.isFinite(number) ? number : null;
};

export const parseVatValueFromLabel = (label) => {
    const match = String(label || "").match(/-?\d+(?:[.,]\d+)?/);

    if (!match) {
        return 0;
    }

    const number = Number(match[0].replace(",", "."));
    return Number.isFinite(number) ? number : 0;
};

export const getVatValueByNdsTypeId = (ndsTypes, ndsTypeId) => {
    const ndsType = (ndsTypes || []).find((item) => item.value === ndsTypeId);
    return parseVatValueFromLabel(ndsType?.label);
};

export const calculateBidFinalPrice = ({ price, priceWithoutVatOnTop, isVatTop, vatValue = 0, useStoredPrice }) => {
    const storedPrice = toNumber(price);

    if (!isVatTop || useStoredPrice) {
        return storedPrice;
    }

    const priceWithoutVat = toNumber(priceWithoutVatOnTop);

    if (priceWithoutVat === null) {
        return storedPrice;
    }

    return priceWithoutVat * (vatValue / 100) + priceWithoutVat;
};

export const calculateBidAverageRate = ({ finalPrice, routeDistanceMeters }) => {
    const normalizedPrice = toNumber(finalPrice);
    const normalizedDistance = toNumber(routeDistanceMeters);

    if (normalizedPrice === null || normalizedDistance === null || normalizedDistance <= 0) {
        return null;
    }

    const routeDistanceKm = normalizedDistance / 1000;
    return routeDistanceKm > 0 ? normalizedPrice / routeDistanceKm : null;
};

export const getRateComparisonMeta = ({ averageRateByDestination, averageRate }) => {
    const marketRate = toNumber(averageRateByDestination);
    const bidRate = toNumber(averageRate);

    if (marketRate === null || bidRate === null || marketRate <= 0 || bidRate <= 0) {
        return null;
    }

    const diff = bidRate - marketRate;

    if (Math.abs(diff) < RATE_COMPARISON_EPSILON) {
        return {
            type: "equal",
            text: "Ставка заявки на уровне рыночной",
            shortText: "На уровне рынка",
            textClassName: "text-muted",
            iconClassName: "text-muted",
        };
    }

    if (diff > 0) {
        return {
            type: "higher",
            text: "Ставка заявки выше рыночной",
            shortText: "Выше рынка",
            textClassName: "text-success",
            iconClassName: "text-success",
        };
    }

    return {
        type: "lower",
        text: "Ставка заявки ниже рыночной",
        shortText: "Ниже рынка",
        textClassName: "text-danger",
        iconClassName: "text-danger",
    };
};
